import { AltsAllocation } from "@/types/investment";

export const transformAllocationsToChartData = (altAllocations: AltsAllocation) => {
  return [
    { name: "Private Equity", value: altAllocations.private_equity_allocation },
    { name: "Private Credit", value: altAllocations.private_credit_allocation },
    { name: "Private Debt", value: altAllocations.private_debt_allocation },
    { name: "Real Estate", value: altAllocations.real_estate_allocation },
    { name: "Hedge Funds", value: altAllocations.hedge_funds_allocation },
    { name: "Commodities", value: altAllocations.commodities_allocation },
    { name: "Cryptocurrencies", value: altAllocations.cryptocurrencies_allocation },
    { name: "Collectibles", value: altAllocations.collectibles_allocation }
  ];
};

export const calculateTotalAllocation = (
  data: { name: string; value: number }[], 
  hiddenSectors: string[]
) => {
  return data
    .filter(item => !hiddenSectors.includes(item.name))
    .reduce((sum, item) => sum + item.value, 0);
};